
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, RefreshCcw } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Função para tentar recarregar a página atual
  const handleRefresh = () => {
    window.location.reload();
  };

  // Função para voltar para a página inicial
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{backgroundColor: "#d4f1f4"}}>
      <div className="text-center max-w-md p-6 rounded-lg shadow-lg bg-white">
        <h1 className="text-5xl font-bold mb-4 text-[#05445e]">404</h1>
        <p className="text-xl text-[#189ab4] mb-6">Página não encontrada</p>
        
        <div className="border-t border-[#75e6da] my-6 pt-6">
          <p className="text-[#05445e] mb-4">
            A página <span className="font-mono bg-[#d4f1f4] px-2 py-1 rounded">{location.pathname}</span> não existe ou ainda está sendo implantada.
          </p>
          
          <p className="text-sm text-gray-600 mb-6">
            Se você está tentando acessar uma preview do projeto, pode ser que o deployment ainda não tenha sido concluído ou que o projeto precise ser publicado.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            onClick={handleRefresh}
            className="bg-[#189ab4] hover:bg-[#05445e] text-white flex items-center gap-2"
          >
            <RefreshCcw size={16} />
            Recarregar página
          </Button>
          
          <Button 
            onClick={handleGoHome}
            variant="outline"
            className="border-[#189ab4] text-[#189ab4] hover:bg-[#75e6da]/20 flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            Voltar ao início
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
